import React, { FC } from 'react';
import onlineTheme from '../../themes/online';
import { DefaultTheme, ThemeProvider as _ThemeProvider } from 'styled-components';
import GlobalStyle from '../../themes/GlobalStyle';

const ThemeProvider = ({ children, theme }: { children?: React.ReactNode; theme?: DefaultTheme }) => (
  <_ThemeProvider theme={onlineTheme}>
    <_ThemeProvider theme={theme || {}}>
      <>
        <GlobalStyle />
        {children}
      </>
    </_ThemeProvider>
  </_ThemeProvider>
  );

export const withTheme = (Comp: FC) => {
  return (props) => {
    return (
      <ThemeProvider>
        <Comp {...props} />
      </ThemeProvider>
    );
  };
};

export default ThemeProvider;
